// src/features/signup/signupSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axiosInstance from "../../httpService/httpService";
import requestPermissionAndGetToken from "../../firebase/getFCMToken";
export const signInUser = createAsyncThunk(
  "signIn/signInUser",
  async (userData, { rejectWithValue }) => {
    const FCM_token = await requestPermissionAndGetToken();
    console.log("FCM TOKEN = " + JSON.stringify(FCM_token)) ;
     // Add the FCM token to the userData object
     const dataWithFCM = { ...userData, fcm_token: FCM_token };

     try {
      const response = await axiosInstance.post(
        "/user/login/user-appsell",
        dataWithFCM
      );
      if (response.status === 200) {
        const { data } = response;
        return {
          userData: data, 
          headers: {
            contentType: response.headers["content-type"],
            contentLength: response.headers["content-length"],
          },
        };
      } else {
        // Handle non-success responses
        throw new Error("Signup failed with status: " + response.status);
      }
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

const signInSlice = createSlice({
  name: "signIn",
  initialState: {
    user: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signInUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(signInUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.userData;
      })
      .addCase(signInUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});
export const { clearError } = signInSlice.actions;
export default signInSlice.reducer;
